
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ActivityTrackerResource,
} from '../models';
import {
    ActivityTrackerResourceFromJSON,
    ActivityTrackerResourceToJSON,
} from '../models';

export interface GetActivityTrackerRequest {
    projectId: string;
    lotId?: string;
}

/**
 * 
 */
export class ActivityTrackerApi extends runtime.BaseAPI {

    /**
     * Fetch an the project activity tracker
          */
    async getActivityTrackerRaw(requestParameters: GetActivityTrackerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ActivityTrackerResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getActivityTracker().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lotId'] != null) {
            queryParameters['lotId'] = requestParameters['lotId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ActivityTrackerResource>({
            path: `/project-client/api/project/{projectId}/activity-tracker`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ActivityTrackerResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch an the project activity tracker
          */
    async getActivityTracker(requestParameters: GetActivityTrackerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ActivityTrackerResource> {
        const response = await this.getActivityTrackerRaw(requestParameters, initOverrides);
        return response._data;
    }

}
